module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1336-retro.d10cb600.jpg";